import axios from "axios";

export function fetchShops() {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/eaa/shops?type=retail`
  };
  return axios(config);
}

export function fetchShopInfo(businessId) {
var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/eaa/shops/${businessId}`
};
return axios(config);
}

export function fetchManagers(accountId) {
    var config = {
        method: "get",
        url: `${process.env.VUE_APP_APIHOST}/eaa/eaa-shops/${accountId}/managers`
    };
    return axios(config);
    }

export function fetchPromotions(data) {
  let businessId = data.businessId;
  let config = {
    method: "GET",
    url: `${process.env.VUE_APP_APIHOST}/eaa/shops/${businessId}/promotions`
  };
  return axios(config);
}